<template>
    <div class="onboarding">
        <div class="page container text-align-center">
            <div id="login">
                <section>
                    <h1 class="title">{{ this.$route.name }}</h1>
                    
                    <p class="desc">
                        <span v-if="$route.name === 'Login'">Welcome back ;)</span>
                        <span v-else>Welcome to OneMgl.</span>
                        <br>
                        Please click button below to {{ this.$route.name }} with Facebook.
                    </p>
                    
                    <button @click="login" class="btn facebook"><span class="facebookIcon">
                        <ion-icon name="logo-facebook"></ion-icon></span> 
                        {{ this.$route.name }} with Facebook
                        <transition name="fade">
                            <div v-if="performingRequest" class="loading small no-margin"></div>
                        </transition>
                    </button>

                    <transition name="fade">
                        <div v-if="errorMsg !== ''" class="error-msg">
                            <p>{{ errorMsg }}</p>
                        </div>
                    </transition>
                    
                </section>
            </div>
        </div>
        <svg class="item1" xmlns="http://www.w3.org/2000/svg" width="312" height="312" viewBox="0 0 312 312"><g transform="translate(-1608 -80)"><path d="M79.715,0A178.881,178.881,0,0,1,239.194,259.769a.751.751,0,0,0,0,.823H15.923s-1.123-.5-1.833-.823C3.342,256.957,1.435,249.375.045,244.272a8.742,8.742,0,0,1,0-1.645V19.615s-.052-.915,1.87-1.848A177.909,177.909,0,0,1,79.715,0Z" transform="translate(1920 340.592) rotate(180)" fill="#e5554a"/><circle cx="83.5" cy="83.5" r="83.5" transform="translate(1608 225)" fill="#67b6ea"/></g></svg>
        <svg class="item2" xmlns="http://www.w3.org/2000/svg" width="368.256" height="396.554" viewBox="0 0 368.256 396.554"><g transform="translate(0.256 -524)"><path d="M180.793,0C303.5,0,402.975,99.474,402.975,222.181a221.617,221.617,0,0,1-24.022,100.592.933.933,0,0,0,0,1.023H101.529s-1.4-.619-2.277-1.023C85.9,319.28,83.527,309.858,81.8,303.518a10.862,10.862,0,0,1,0-2.043V24.373s-.065-1.137,2.323-2.3A221.06,221.06,0,0,1,180.793,0Z" transform="translate(-82 596.758)" fill="#ffc107" opacity="0.698"/><circle cx="119" cy="119" r="119" transform="translate(130 524)" fill="#34aa59"/></g></svg>
    </div>
</template>

<script>
    const fb = require('@/firebaseConfig.js')

    export default {
        data() {
            return {
                performingRequest: false,
                errorMsg: ''
            }
        },
        methods: {
            login() {
                this.performingRequest = true

                let self = this
                let provider = fb.faceAuthProvider

                // Scopes
                // provider.addScope('user_link')
                
                fb.auth.signInWithRedirect(provider).then(result => {

                    let user = result.user
                    
                    console.log('Login success: ', user.uid, result)

                    self.$store.commit('setCurrentUser', user)

                    let userRef = fb.usersCollection.doc(user.uid)

                    let fullName = user.displayName
                    let firstName = typeof(user.displayName) !== 'undefined' ? fullName.split(' ').slice(0, -1).join(' ') : null
                    let lastName = typeof(user.displayName) !== 'undefined' ? fullName.split(' ').slice(-1).join(' ') : null
                    let sendEmail = typeof(user.email) !== 'undefined' !== null ? true : false
                    let sendTxt = typeof(user.phoneNumber) !== 'undefined' ? true : false
                    let phoneNumber = typeof(user.phoneNumber) !== 'undefined' ? user.phoneNumber : null
                    let location = typeof(user.location) !== 'undefined' ? user.location : null

                    let userProfileData = {
                        displayName: fullName,
                        firstName: firstName,
                        lastName: lastName,
                        email: user.email,
                        emailVerified: user.emailVerified,
                        phoneNumber: phoneNumber,
                        photoURL: user.photoURL,
                        uid: user.uid,
                        isMember: false,
                        darkMode: true,
                        timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                        settings: {
                            sendEmail: sendEmail,
                            sendTxt: sendTxt
                        },
                        points: 0,
                        metadata: null,
                        providerData: null,
                        
                        // Location
                        location: location,
                        
                        // Facebook
                        facebook: null
                    }

                    // Set Facebook Info
                    if(typeof result.credential !== 'undefined'){
                        if(userProfileData.facebook === null) {
                            userProfileData.facebook = {}
                        }
                        userProfileData.facebook.accessToken = result.credential.accessToken
                    }
                    if(typeof result.additionalUserInfo !== 'undefined'){
                        if(userProfileData.facebook === null) {
                            userProfileData.facebook = {}
                        }
                        userProfileData.facebook.profile = result.additionalUserInfo.profile
                    }

                    // Set Metadata
                    if(typeof(user.metadata) !== 'undefined'){
                        
                        let metadata = {
                            a: user.metadata.a,
                            b: user.metadata.b,
                            creationTime: user.metadata.creationTime,
                            lastSignInTime: user.metadata.lastSignInTime
                        }

                        userProfileData.metadata = {}
                        userProfileData.metadata = metadata
                    }

                    // Set ProviderData
                    if(typeof(user.providerData) !== 'undefined'){
                        userProfileData.providerData = user.providerData
                    }

                    // Check User Profile
                    userRef.get().then(userData => {

                        // New Users
                        if(!userData.exists){

                            // Set User Profile
                            userRef.set(userProfileData).then(() => {

                                console.log('User profile successfully set: ', userProfileData)

                                self.$store.dispatch('fetchUserProfile', user)
                                self.performingRequest = false
                                self.$router.push('/welcome1')
                            
                            }).catch(userProfileErr => {

                                console.log('User profile set error: ', userProfileErr)
                                
                                self.performingRequest = false
                            })
                        
                        // Existing User : Use from profile
                        }else{
                            // Update Facebook Info
                            let updates = {
                                facebook: userProfileData.facebook
                            }
                            if(updates.facebook !== null){
                                userRef.update(updates).then(() => {
                                    console.log('Updated user additional info: ', updates)
                                })
                            }

                            console.log('User profile: ', userData.data())

                            self.$store.dispatch('fetchUserProfile', user)
                            self.performingRequest = false
                            self.$router.push('/welcome1')
                        }
                    }).catch(userErr => {
                        console.log('User profile error: ', userErr)
                        self.performingRequest = false
                    })
                    
                }).catch(err => {
                    console.log('Login error: ', err)
                    self.performingRequest = false
                    self.errorMsg = err.message
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Login.vue